<template>
  <div id="header">

    <nav class="navbar navbar-expand-lg navbar-light">
      <div class="container-fluid">
        <a class="navbar-brand" href="#/"><h1 style="display:inline;"><b>LIFE</b></h1></a>
        <!-- <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button> -->

        <div class="" id="navbarSupportedContent">

          <ul class="navbar-nav me-auto mb-2 mb-lg-0">
            </li>
          </ul>

          <ul class="navbar-nav mr-auto mb-2 mb-lg-0">
            <li class="nav-item">
              <a class="nav-link active mypage-link" aria-current="page" href="#/mypage">
                MY PAGE
                <!-- <div class="container-fluid">
                  <div class="row">
                  <div>
                    <jazzicon address="0x3615AE16eA2eCe2840194a07044567ba6862a50C" :diameter="20" />
                  </div>
                  <div>
                    0x361...a50C
                  </div>
                  </div>
                </div> -->
              </a>
            </li>
            </li>
          </ul>
          <!-- <form class="d-flex">
            <input class="form-control" type="search" placeholder="Search" aria-label="Search">
            <button class="btn btn-outline-success" type="submit">Search</button>
          </form> -->
        </div>
      </div>
    </nav>

    <!-- <b-navbar>
      <b-navbar-brand>
        <b-nav-item to="/"><b><h3 style="display:inline;">LIFE</h3></b></b-nav-item>
      </b-navbar-brand>
      <b-navbar-nav mr-auto>
        <b-nav-item href="#/mypage">MyPage</b-nav-item>
      </b-navbar-nav>
    </b-navbar> -->
  </div>

</template>


<script>
import Jazzicon from 'vue3-jazzicon/src/components';
import Web3Util from "../web3_util.js"
import db from "../firebase.js"

export default {
  // name: 'uHeader',
  components: {
    Jazzicon,
  },
  data () {
    return {
      data: [],
      address: null,
      is_ethereum: false
    }
  },
  mounted: async function () {

    if (this.is_ethereum){
      let accounts = await ethereum.request({ method: 'eth_accounts' });
      this.address = accounts[0]//web3.utils.toChecksumAddress(accounts[0])
    }
    // console.log(accounts[0])
    console.log(this.address)
    // console.log("0x3615ae16ea2ece2840194a07044567ba6862a50c")
    // let test = "0x646101A558FD11B7426176248964272D296c0Ee7"

    db.collection("info")
      .where("owner", "==", this.address)
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          // console.log(`${doc.id} => ${doc.data().image}`)
          this.data.push(doc.data())
        })
      })
    this.is_ethereum = await Web3Util.load();
  },

  methods: {
    getOwnedLifes: function (event, address) {
      console.log(address)
      Web3Util.deposit(address, this.txtInput);//133238529999900
      // if (event) {
      //   alert(event.target.tagName)
      // }
    },
  },
  // mounted: async function(){
  //   console.log("mounted")//デバッグ用
  //   // this.items = await poke()
  // },
}

</script>

<style>

#header{
  padding: 0px 30px;
  /* text-align: right; */
}

.navbar{
  padding-top: 0px;
  font-family: 'Noto Sans JP';
}

.mypage-link{
  font-size: 20px;
}

a.mypage-link {
  background-color: gold;
}

a.mypage-link:hover {
  text-decoration:underline;
}

/* a:hover {
  background-color: gold;
} */

</style>



// WEBPACK FOOTER //
// src/components/Header.vue